"use client";

import { useAppContext } from "/context/app-context";
import ClientSideHeader from "/global-layout/headerDetection";
import Footer from "/global-layout/footer";
import TermlyCMP from "/global-layout/global-components/termlyEmbedScript";

export default function LayoutShell({
  children,
}: {
  children: React.ReactNode;
}) {
  const { inAppMode, device } = useAppContext();
  return (
    <>
      {!inAppMode && <ClientSideHeader />}
      {children}
      {!inAppMode && <Footer />}
    </>
  );
}
